export const findDelegateLinkedNodes = payload => {
    try {
        if(payload === undefined || payload === undefined){
            console.error(`Finding delegate linked nodes failed. Value of 'payload' is undefined/null `);
            return null;
        }
   
        const { id, events, clusterlets } = payload;
        const nodesLinkedToDelegate = events?.map(event => {
        
            /**one node must be delegate and the other node must not be delegate */
            if (event.src === id && clusterlets.find(item => item._id === event.dst).type !== 1) return event.dst;
            if (event.dst === id && (1 !== clusterlets.find(item => item._id === event.src).type)) return event.src;
        })
    const nodes = Array.from(new Set(nodesLinkedToDelegate));
    let clusterletKeyValuePairs = []
  
    clusterlets.map(item => {
      if (nodes.includes(item._id)) clusterletKeyValuePairs.push({ value: item._id, label: item.name })
    })
  
    const alphabeticallyArrangedList = clusterletKeyValuePairs.sort(function (a, b) {
      return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
    })
  
    return alphabeticallyArrangedList;

    } catch (error) {
        console.error(`Finding delegate linked nodes failed. ${error}`);
    }
  }


export const getUniqueAttributesByName = (data) => {
    const allObjects = data.flat();
    const uniqueObjects = Array.from(
        new Map(
            allObjects.map((obj) => [obj.name, obj])
        ).values()
    );
    return uniqueObjects;
};


export const generateSingleAttributeSchema = (attributeSchema, selectedDelegate, events, clusterlets, tag) => {
    try {
        
    
    let editorSchema = {
        type: "string",
        title: attributeSchema?.args?.desc,
        options: { layout: 'grid', grid_columns: 12 },
        readOnly: attributeSchema?.args?.default ? true : false,
    };
    if (attributeSchema?.children && attributeSchema?.children?.length > 0) {
        let options = attributeSchema.children.filter(child => child.type === 'field').map(child => {
            return { title: child.name, value: child.args?.value };
        });
        options = options ? options : [];
        editorSchema.enumSource = [{
            source: [{ title: `Select ${editorSchema.title}`, value: 'select' }, ...options],
            title: '{{item.title}}',
            value: '{{item.value}}'
        }];
    }

    if (selectedDelegate && attributeSchema.name === "ttype") {

        const delegateLinkedNodes = findDelegateLinkedNodes({ id: selectedDelegate._id, events, clusterlets });

        let options = delegateLinkedNodes?.map(clusterlet => {
            return { title: clusterlet.label, value: clusterlet.value };
        });
        editorSchema.enumSource = [{
            source: [{ title: `Select Clusterlet`, value: 'select' }, ...options],
            title: '{{item.title}}',
            value: '{{item.value}}'
        }];
        editorSchema.readOnly = tag === 'event' ? true : false;

    }

    if (attributeSchema.name === "tcmd") {
        let options = events?.map(event => {
            return { title: event.name, value: event._id };
        });
        editorSchema.enumSource = [{
            source: [{ title: `Select Event`, value: 'select' }, ...options],
            title: '{{item.title}}',
            value: '{{item.value}}'
        }];
        editorSchema.readOnly = tag === 'event' ? true : false;

    }

    return editorSchema;

    } catch (error) {
        console.error(`Generating single attribute schema failed. ${error}`);
    }
}




export const findEditorSchemaOfSelectedTemplate = ({ filteredTemplateSchema, clusterlets, events, selectedDelegate, tag }) => {
    try {
      if(filteredTemplateSchema === undefined || filteredTemplateSchema === null){
        console.error(`Finding editor schema for selected template failed. Value of  'filteredTemplateSchema' is null/undefined `)
        return null;
      }
    
    const selectedTemplateSchema = JSON.parse(JSON.stringify(filteredTemplateSchema));
   
    let formSchema = {
        title: "Routing Rules",
        type: 'object',
        required: [],
        options: {
            layout: 'grid',
            disable_properties: 'false',
        },
        properties: {}
    };

    selectedTemplateSchema.forEach(item => {
        formSchema.properties[item.name] = generateSingleAttributeSchema(item, selectedDelegate, events, clusterlets, tag);
    });

    formSchema.required = selectedTemplateSchema.filter(item => item.args.optional !== "true").map(item => item.name);
   
    return formSchema;

  
    } catch (error) {
        console.error(`Finding editor schema for selected template failed. ${error}`)
    }
}

